<template><div><h1>VUX V2.3.7 发布日志</h1>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[feature] 可以使用 :show.sync 来控制控件显示 #1358</li>
<li>[fix] 修复格式为 YYYY-MM 时的日期范围错误 #1528</li>
<li>[feature] 支持通过 prop:hourList prop:minuteList 自定义小时和分钟列表</li>
<li>[fix] 开始日期年份应该覆盖最小年份(minYear) #1358</li>
</ul>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[feature] 添加 slot:title</li>
</ul>
<h2><a href="/zh-CN/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[feature] 添加 slot:each-item</li>
</ul>
<h2><a href="/zh-CN/components/popup.html">Popup</a></h2>
<ul><li>[fix] 修复默认值为 true 时遮罩没有显示的问题 #1555</li>
</ul>
<h2><a href="/zh-CN/components/x-number.html">XNumber</a></h2>
<ul><li>[fix] 修复值类型 #1554</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.3.7 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.3.7-235.vue?1ec50220